export default __webpack_public_path__ + "static/media/niveau-pep.446f973a.svg";